var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleTable',{attrs:{"formclass":"pages/City/form","endpoint":"api/v2/city","aditionalColumns":_vm.headers}},[[_c('h1',[_vm._v("Cidades")]),_c('v-divider',{staticClass:"mb-4"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }